import React from 'react';
import './ModifierName.less';

export const ModifierName = ({text, isSmall}) => {
	return <span className={`modifier-name ${isSmall ? 'modifier-name--small' : ''}`}>{text}</span>;
};
